import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'common/hook';
import { headerItems } from 'components/header/contacts/index';
import useBeforeInstallPrompt from 'common/hook/useBeforeInstallPrompt';
import { isIOS } from 'react-device-detect';

export const Contacts = () => {
    const { handleInstallClick, isPromptEvent, showInstallButton,choiceResult  } = useBeforeInstallPrompt();
    const roleType = useAppSelector((state) => state.role.roleType);

    const [isAppInstalled, setIsAppInstalled] = useState(false);

    useEffect(() => {
        if (choiceResult && choiceResult.outcome === 'accepted') {
            setIsAppInstalled(true);
        }
    }, [choiceResult]);

    const currentYear = new Date().getFullYear();


    return (
        <div className="hdr-contacts">
            {headerItems.map((item, index) => (
                (item.userType === 'all' || item.userType === roleType) && (
                    <div key={index} className="item">
                        {item.link ? (
                            <p className="p-icon">
                                <a className='hover' href={item.link}>{item.title}</a>
                                <span className="icon">{item.icon}</span>
                            </p>
                        ) : (
                            item.tell && (
                                <>
                                    <span className="contact-person">{item.title}</span>
                                    <p className="p-icon">
                                        <a className='hover' href={item.path}>{item.tell}</a>
                                        <span className="icon">{item.icon}</span>
                                    </p>
                                </>
                            )
                        )}

                        {(!isIOS && !isAppInstalled && item.appText && showInstallButton) && (
                            <p className="p-icon">
                                <button onClick={handleInstallClick} className="js-install-pwa hover">{item.appText}</button>
                                <span className="icon">{item.icon}</span>
                            </p>
                        )}
                    </div>
                )
            ))}
            <p className="copy">Online Class &copy; {currentYear}</p>
        </div>
    );
};

